import React from "react";
import "./typography.scss";

// Defining the HTML tag that the component will support
const variantsMapping = {
    display1: "h1",
    display2: "h2",
    display3: "h3",
    display4: "h4",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle: "p",
    buttonText: "p",
    labels: "p",
    hintText: "p",
    body1: "p",
    body2: "p",
    link: "a",
};

const Typography = ({ variant, children, className, color, ...props }) => {
    const Component = variant ? variantsMapping[variant] : "p";

    return (
        <Component
            className={`typography--variant-${variant} ${className}`}
            style={{ color: color }}
            {...props}
        >
            {children}
        </Component>
    );
};

export default Typography;
